import { AxiosInstance } from 'axios';

import { APIManagerConfig } from '../apiManager';
import { ReportType } from '../../../store/entities/reports/reports.constants';
import { AutomatedReport } from '../../../store/entities/automatedReports/automatedReports.types';

const AutomatedReportsServiceFactory = ({
  HTTPBase,
  config,
}: {
  HTTPBase: AxiosInstance;
  config: APIManagerConfig;
}) => {
  return {
    getAutomatedReportsList: (reportType: ReportType): Promise<AutomatedReport[]> =>
      HTTPBase.get(`farm/${config.farmId}/reports/${reportType}/automate`).then((res) => res.data),
    getAutomatedReport: (reportType: ReportType, automateReportId: string): Promise<AutomatedReport> =>
      HTTPBase.get(`farm/${config.farmId}/reports/${reportType}/automate/${automateReportId}`).then((res) => res.data),
    postAutomatedReport: (reportType: ReportType, payload: Partial<AutomatedReport>): Promise<AutomatedReport> =>
      HTTPBase.post(`farm/${config.farmId}/reports/${reportType}/automate`, payload).then((res) => res.data),
    updateAutomatedReport: (reportType: ReportType, payload: Partial<AutomatedReport>): Promise<AutomatedReport> =>
      HTTPBase.patch(`farm/${config.farmId}/reports/${reportType}/automate/${payload.id}`, payload).then(
        (res) => res.data,
      ),
    deleteAutomatedReport: (reportType: ReportType, automateReportId: string): Promise<any> =>
      HTTPBase.delete(`farm/${config.farmId}/reports/${reportType}/automate/${automateReportId}`).then(
        (res) => res.data,
      ),
  };
};

export default AutomatedReportsServiceFactory;
